import _Symbol_default from "./_Symbol.js";
import isSymbol_default from "./isSymbol.js";
import _arrayMap_default from "./_arrayMap.js";
import isArray_default from "./isArray.js";

//#region ../../node_modules/lodash-es/_baseToString.js
/** Used as references for various `Number` constants. */
var INFINITY = Infinity;
/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol_default ? _Symbol_default.prototype : void 0, symbolToString = symbolProto ? symbolProto.toString : void 0;
/**
* The base implementation of `_.toString` which doesn't convert nullish
* values to empty strings.
*
* @private
* @param {*} value The value to process.
* @returns {string} Returns the string.
*/
function baseToString(value) {
	if (typeof value == "string") return value;
	if (isArray_default(value)) return _arrayMap_default(value, baseToString) + "";
	if (isSymbol_default(value)) return symbolToString ? symbolToString.call(value) : "";
	var result = value + "";
	return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
var _baseToString_default = baseToString;

//#endregion
export { _baseToString_default as default };
//# sourceMappingURL=_baseToString.js.map